import { useCallback, useEffect, useState } from 'react';
import { useAuth0Params } from '../hooks/useAuth0Params';
import { getTenantDetail } from '../services/api';
import AuthContext from './AuthContext';
const initialState = {
  tenantDetail: null,
  params: null,
  isConsole: false
};
const AuthProvider = ({ children }) => {
  const params = useAuth0Params();
  const [data, setData] = useState(initialState);
  const setContextData = useCallback(
    (newData) => {
      const isConsole =
        JSON.parse(params?.console || 'false') ||
        JSON.parse(process.env?.REACT_APP_PARTNER || 'false');

      setData({
        ...data,
        ...newData,
        isConsole
      });
    },
    [data, params?.console]
  );
  const initialize = () => {
    if (process.env?.REACT_APP_PARTNER) {
      loadTenantDetail();
      return;
    }
    setContextData({
      params
    });
  };
  const loadTenantDetail = useCallback(() => {
    getTenantDetail(params)
      .then((res) => {
        setContextData({
          tenantDetail: res?.data,
          params
        });
      })
      .catch(() => {
        setContextData({
          tenantDetail: null
        });
      });
  }, [params, setContextData]);
  useEffect(() => {
    if (params) {
      initialize();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return (
    <AuthContext.Provider value={{ data, setContextData }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
